import React, { useState } from "react";
import { X, KeyRound } from "lucide-react";
import api, { fmtErr } from "../api/axios";

export default function ChangePasswordModal({ onClose }) {
  const [currentPwd, setCurrentPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPwd.length < 8) {
      setError("New password must be at least 8 characters");
      return;
    }
    if (newPwd !== confirmPwd) {
      setError("New password and confirmation do not match");
      return;
    }
    if (newPwd === currentPwd) {
      setError("New password must be different from current password");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/change-password", {
        current_password: currentPwd,
        new_password: newPwd,
      });
      setSuccess(true);
      setTimeout(() => onClose(), 1500);
    } catch (err) {
      setError(fmtErr(err.response?.data?.detail) || "Password change failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card modal-sm" onClick={(e) => e.stopPropagation()} data-testid="change-password-modal">
        <div className="modal-header">
          <h3><KeyRound size={16} style={{ display: "inline", marginRight: 8 }} />Change Password</h3>
          <button className="modal-close" onClick={onClose} data-testid="close-change-password"><X size={18} /></button>
        </div>
        <div className="modal-body">
          {success ? (
            <div className="success-box" data-testid="change-password-success">
              ✓ Password updated. You stay logged in.
            </div>
          ) : (
            <form onSubmit={submit}>
              <div className="form-group">
                <label className="form-label">Current Password</label>
                <input
                  type={showPwd ? "text" : "password"}
                  className="form-input"
                  value={currentPwd}
                  onChange={(e) => setCurrentPwd(e.target.value)}
                  required autoFocus autoComplete="current-password"
                  data-testid="current-password-input"
                />
              </div>
              <div className="form-group">
                <label className="form-label">New Password (min 8 chars)</label>
                <input
                  type={showPwd ? "text" : "password"}
                  className="form-input"
                  value={newPwd}
                  onChange={(e) => setNewPwd(e.target.value)}
                  required minLength={8} autoComplete="new-password"
                  data-testid="new-password-input"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm New Password</label>
                <input
                  type={showPwd ? "text" : "password"}
                  className="form-input"
                  value={confirmPwd}
                  onChange={(e) => setConfirmPwd(e.target.value)}
                  required minLength={8} autoComplete="new-password"
                  data-testid="confirm-password-input"
                />
              </div>
              <label
                style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 12, marginBottom: 12 }}
                data-testid="show-password-toggle"
              >
                <input type="checkbox" checked={showPwd} onChange={(e) => setShowPwd(e.target.checked)} />
                Show passwords
              </label>
              {error && <div className="error-box" data-testid="change-password-error">{error}</div>}
              <div className="modal-footer">
                <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
                <button type="submit" className="btn-primary" disabled={loading} data-testid="change-password-submit">
                  {loading ? "Updating..." : "Update Password"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
